import { useParams } from 'react-router';
import { ErrorState } from '@/components/molecules/ErrorState';
import { SyncOutcomeScreen } from '@/features/zones/components/SyncOutcomeScreen';

/**
 * Outcome screen for a Notion sync job. Thin wrapper
 * that reads the job id from the route and hands it to
 * `SyncOutcomeScreen`, which streams live SSE progress and then renders
 * the terminal per-row outcome.
 */
export function ZoneImportOutcomePage() {
  const { jobId } = useParams<{ jobId: string }>();

  if (!jobId) {
    return (
      <section className="container mx-auto mt-14 px-4 py-12">
        <ErrorState
          title="Missing job ID"
          description="Open this page from a real sync outcome link."
        />
      </section>
    );
  }

  return (
    <section className="container mx-auto mt-14 px-4 py-12">
      <SyncOutcomeScreen jobId={jobId} />
    </section>
  );
}

// react-router's route registration in `src/components/App.tsx` consumes
// the page via a default import; keep both exports so the named-export
// convention and the router wiring both hold.
export default ZoneImportOutcomePage;
